import { CONFIRMACAO_FIELDS } from '../../consts/text/confirmacao-seguranca';
import { Yup } from '../../utils';

export const formSchema = Yup.object().shape({
    [CONFIRMACAO_FIELDS.CODIGO_ACESSO]: Yup.number().required(),
});
